import { Button, Input, Typography, message } from "antd";
import Card from "../../components/Card";
import { useState } from "react";
import { AuthService } from "../../services/AuthService";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;

const NewCategory = () => {
    const navigate = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [category, setCategory] = useState({
        categoryId: 0,
        categoryName: null
    })

    const saveCategory = async () => {
        setLoading(true);
        let { categoryName } = category;
        if (!categoryName) {
            messageApi.open({
                type: 'error',
                content: 'Ploteso fushat e shenuara me *',
            });
            setLoading(false);
            return;
        }
        let res = await AuthService.createCategory(category)
        if (res) {

            messageApi.open({
                type: 'success',
                content: 'Vlera u ruajt me sukses',
            });
            setTimeout(() => {
                setLoading(false);
                navigate(`/categories`);
            }, 1000);
        }
    }


    return (
        <div className="container">
            {contextHolder}
            <div className="row">
                <div className="col-lg-8">
                    <Card title="Add new category">
                        <form action="">
                            <div className="row">
                                <div className="col-12">
                                    <Text>Emri i kategoriese</Text>
                                    <Input value={category?.categoryName} onChange={(e) => setCategory({ ...category, categoryName: e.target.value })} />
                                </div>
                                <div className="col-12 mt-3">
                                    <div className="d-flex justify-content-end">
                                        <Button type="primary" loading={loading} disabled={loading} onClick={saveCategory}>Ruaj kategorine</Button>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </Card>
                </div>
            </div>
        </div>
    )
}


export default NewCategory;